var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account-favorites" },
    [
      _vm._m(0),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _vm.isLoading
            ? _c("ui-loader", {
                key: "loader",
                staticClass: "account-favorites__loader",
                attrs: { size: "60" }
              })
            : _c(
                "div",
                [
                  _vm.hasFavorites
                    ? _c("favorite-gallery", {
                        attrs: {
                          products: _vm.products,
                          "is-end": _vm.isEnd,
                          "is-loading": _vm.isLoadingProducts
                        },
                        on: { load: _vm.loadFavoritesProducts }
                      })
                    : _c(
                        "page-info",
                        {
                          attrs: {
                            title: "Список избранных товаров пуст",
                            subtitle:
                              "Добавьте товары в список избранных, чтобы было проще оформить следующий заказ"
                          }
                        },
                        [
                          _c("ui-button", {
                            ref: "startBuyBtn",
                            attrs: { text: "Начать покупки" },
                            on: { click: _vm.startBuy }
                          })
                        ],
                        1
                      )
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "account-favorites__title" }, [
      _c("h2", [_vm._v("Избранное")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }